const t=({depositType:t,showDepositTypeInMaturity:e,maturity:o})=>e&&o?"":t;export{t as default};
//# sourceMappingURL=createDepositTypeInfo.js.map
